import { Component, ViewChild } from '@angular/core';
import { ReportFileService } from '../../shared/report-file.service';
import { ApiService, DatagridService, TranslationService } from 'src/app/shared';
import { ReportInfoDto } from '../../shared/dto/report-info.dto';
import { DataView as PrimeDataList } from 'primeng/dataview';

@Component({
  selector: 'wl-report-custom-report-files',
  templateUrl: './report-custom-report-files.component.html',
  styleUrl: './report-custom-report-files.component.less',
    standalone: false
})
export class ReportCustomReportFilesComponent {
  @ViewChild('customReportNamesReultsGrid', { static: false })
  private _customReportNamesReultsGrid: PrimeDataList;

  public customReportFileNames = new Array<ReportInfoDto>();
  public searching: boolean = false;
  public showUpload: boolean = false;
  public downloadReportButtonText: string;
  public fileUploadApiUrl: string;
  public selectAll: boolean = false;

  constructor(
    private _reportFileService: ReportFileService,
    private _datagridService: DatagridService,
    private _translationService: TranslationService,
    private _apiService: ApiService
  ) {}

  ngOnInit() {
    this.searching = true;

    //note all you need to do is set the api endpoint url
    //the standard AuthInterceptor HttpInterceptor set in app.component will add the bearer token to the request
    this.fileUploadApiUrl = this._apiService.getBaseUrl() + '/report/custom/file';
    this.loadCustomReportNames();
  }
  public loadCustomReportNames(): void {
    this._reportFileService.getCustomReportNames().then((data: Array<ReportInfoDto>) => {
      this.searching = false;
      this.customReportFileNames = data;
      this._customReportNamesReultsGrid.value = data;
      this.updateDownloadReportButtonText();
    });
  }

  public handleDownloadClick(reportName: string): void {
    this._reportFileService.downloadCustomReport(reportName);
  }

  public handleDownloadMultipleReportsClick(): void {
    for (let report of this.customReportFileNames) {
      if (report.Selected == true) {
        this._reportFileService.downloadCustomReport(report.ReportName);
      }
    }
  }

  public handleUploadReports(): void {
    this.showUpload = true;
  }

  public getSelectedCount(): number {
    let selectedCount = 0;
    for (let report of this.customReportFileNames) {
      if (report.Selected == true) {
        selectedCount = selectedCount + 1;
      }
    }
    return selectedCount;
  }

  public updateDownloadReportButtonText(): string {
    let displayText = '';
    let selectedCount = this.getSelectedCount();

    if (selectedCount > 0) {
      displayText =
        this._translationService.getInstantTitlecase('common.download') +
        ' ' +
        selectedCount.toString() +
        ' ' +
        this._translationService.getInstantTitlecase('common.reports');
    } else {
      displayText =
        this._translationService.getInstantTitlecase('common.download') +
        ' ' +
        this._translationService.getInstantTitlecase('common.reports');
    }
    this.downloadReportButtonText = displayText;

    return displayText;
  }

  public handleSelectAll(): void {
    for (let report of this.customReportFileNames) {
      report.Selected = !this.selectAll;
    }

    this.selectAll = !this.selectAll;
    this.updateDownloadReportButtonText();
  }

  public handleAfterUpload(): void {
    this.loadCustomReportNames();
  }
}
